import { path as getPath } from 'ramda';

import { defaultTheme } from '../app/styles/themes';

const getThemeProp = path => getPath(['theme', ...path]);

export const getThemeColor = path => getThemeProp(['colors', ...path]);
export const getThemeSize = path => getThemeProp(['sizes', ...path]);
export const getScreenSize = path => getThemeProp(['screens', ...path]);
export const getThemeFont = path => getThemeProp(['fonts', ...path]);

export const getDirectThemPath = path => getPath(path, defaultTheme);